(function () {
  class CclpQuizReviews extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._onSectionLoad = this._onSectionLoad.bind(this);
      this._dotHandlers = [];
    }

    connectedCallback() {
      document.addEventListener('shopify:section:load', this._onSectionLoad);
      this._init();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      this._destroy();
    }

    _onSectionLoad(event) {
      var target = event.target;
      if (target && typeof target.contains === 'function' && target.contains(this)) {
        this._init();
      }
    }

    _init() {
      this._destroy();
      this._track = this.querySelector('[data-track]');
      this._dots = this.querySelector('[data-dots]');
      if (!this._track || !this._dots) return;

      var cards = this._track.children;
      if (!cards.length) return;

      this._dotHandlers = [];
      for (var i = 0; i < cards.length; i++) {
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) button.setAttribute('aria-current', 'true');

        var handler = (function (card) {
          return function () {
            card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          };
        })(cards[i]);

        button.addEventListener('click', handler);
        this._dotHandlers.push({ button: button, handler: handler });
        this._dots.appendChild(button);
      }

      this._track.addEventListener('scroll', this._onScroll, { passive: true });
    }

    _destroy() {
      if (this._track) {
        this._track.removeEventListener('scroll', this._onScroll);
      }

      if (this._dotHandlers && this._dotHandlers.length) {
        this._dotHandlers.forEach(function (item) {
          item.button.removeEventListener('click', item.handler);
        });
        this._dotHandlers = [];
      }

      if (this._dots) {
        this._dots.replaceChildren();
      }

      this._track = null;
      this._dots = null;
    }

    _onScroll() {
      if (!this._track || !this._dots) return;

      var cards = this._track.children;
      if (!cards.length) return;

      var idx = Math.round(this._track.scrollLeft / (cards[0].offsetWidth + 12));
      if (idx < 0) idx = 0;
      if (idx >= cards.length) idx = cards.length - 1;

      Array.prototype.forEach.call(this._dots.children, function (dot, i) {
        if (i === idx) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('cclp-quiz-reviews')) {
    customElements.define('cclp-quiz-reviews', CclpQuizReviews);
  }
})();
